import { useState, useEffect, useCallback } from 'react';

/**
 * Tracks reading progress as a percentage of the scrollable page height.
 * Returns a 0-100 value updated on scroll.
 */
const useReadingProgress = () => {
  const [progress, setProgress] = useState(0);

  const handleScroll = useCallback(() => {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement?.scrollHeight - document.documentElement?.clientHeight;
    if (docHeight <= 0) {
      setProgress(100);
      return;
    }
    const pct = Math.min(100, Math.round((scrollTop / docHeight) * 100));
    setProgress(pct);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // initial calc
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return progress;
};

export default useReadingProgress;
